import { render, staticRenderFns } from "./WarehouseTransferDetailPage.vue?vue&type=template&id=b7528b4e&"
import script from "./WarehouseTransferDetailPage.vue?vue&type=script&lang=ts&"
export * from "./WarehouseTransferDetailPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b7528b4e')) {
      api.createRecord('b7528b4e', component.options)
    } else {
      api.reload('b7528b4e', component.options)
    }
    module.hot.accept("./WarehouseTransferDetailPage.vue?vue&type=template&id=b7528b4e&", function () {
      api.rerender('b7528b4e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/logistic/warehouse-transfer/WarehouseTransferDetailPage.vue"
export default component.exports